import { GET_LOCATION_LIST, GET_LOCATION_LIST_FAIL, GET_LOCATION_LIST_SUCCESS } from '../types';

const initState = {
  locations: [],
  error: null,
  isLoading: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_LOCATION_LIST: {
      return { ...state, isLoading: true };
    }

    case GET_LOCATION_LIST_SUCCESS: {
      const { payload } = action;

      return { ...state, isLoading: false, locations: payload, error: null };
    }

    case GET_LOCATION_LIST_FAIL: {
      const { payload } = action;

      return { ...state, isLoading: false, locations: [], error: payload };
    }

    default:
      return state;
  }
};
